import React, {useEffect, useRef, useState} from 'react';
import {BookBoxDrawerCart, ContainerHeader} from "../../module";
import "./Order.css"
import Grid from "@mui/material/Grid";
import {useHistory, useParams} from "react-router";
import {useSelector, useDispatch} from "react-redux";
import {selOrder} from "../../../stores/order/slice";
import {changeOrderStatus, getOrderById, printFactor} from "../../../stores/order/thunk";
import {Step, StepLabel, Stepper, TableCell} from "@mui/material";
import separate from "../../functions/separate/separate";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import {Link} from "react-router-dom";
import defaultImage from "../../../Image/defaultBook.png";
import axios from "axios";
import {strings} from "../../../strings";
import {selToken} from "../../../stores/base/baseSlice";
import {trackPromise} from "react-promise-tracker";
import ReactToPrint from "react-to-print";

function getSteps() {
    return ['پرداخت', 'تایید فروشگاه', 'تایید انبار', 'ارسال نهایی'];
}

export default function Order() {

    const {id} = useParams();
    const order = useSelector(selOrder);

    const dispatch = useDispatch();
    const history = useHistory();
    const token = useSelector(selToken)

    const [isMarghoom, setIsMarghoom] = useState(false);
    const [viewGoods, setViewGoods] = useState(false);
    const [orderBarcode, setOrderBarcode] = useState(null);

    const steps = getSteps();

    const [activeStep, setActiveStep] = useState(2);
    const [skipped, setSkipped] = useState(new Set());
    let componentRef = useRef();

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    function Unit(props) {
        const {data} = props;

        return (
            <TableRow key={data.product_id}>
                <TableCell component="th" scope="row">
                    <div className="d-flex BoxBookInTable align-items-center">
                        {/*<i className="fas fa-times c-pointer"  onClick={() => dispatch({*/}
                        {/*   type: "DELETE_PRODUCT_OF_CART",*/}
                        {/*   data: data.product_id*/}
                        {/*})}/>*/}
                        <img src={data.images ? data.images.length !== 0 && data.images[0].url : defaultImage} alt=""/>
                        <a href={`https://www.nashresra.ir/products/${data.slug}`} target="_blank">
                            <h3>{data.name}</h3>
                            {order?.details && <span>{order?.details?.marghomeLicence}</span>}
                        </a>
                    </div>
                </TableCell>
                <TableCell align="right">
                    <div className="DivParentPriceInTableCart">
                        {/*<h3 className="percent">%10</h3>*/}
                        {/*<h3 className="lastPrice">{separate(data.price)} ریال</h3>*/}
                        <h3 className="mainPrice">{separate(data.price)} ریال</h3>
                    </div>
                </TableCell>
                <TableCell align="center">
                    <div className="w-100 d-flex justify-content-center">
                        {data.quantity}
                    </div>
                </TableCell>
                <TableCell align="center">
                    <div className="finalPrice">
                        <h3>{separate(data.price * data.quantity)} ریال</h3>
                    </div>
                </TableCell>
            </TableRow>
        )
    }

    function setStatusOrder(status) {
        switch (status) {
            case 100 :
                return setActiveStep(1);
            case 1:
                return setActiveStep(2);
            case 2:
                return setActiveStep(3);
            case 3:
                return setActiveStep(4);
            case 5:
                return setActiveStep(4);
        }
    }

    const callBack =( res )=> {
        setStatusOrder(res.topin_status);
        setOrderBarcode(res.topin_barcode)
        res.products.map((product) => {
            if (!product?.user_count) {
                setIsMarghoom(false)
            } else if(res.products.length === 1){
                setIsMarghoom(true)
            }
        })
    }

    useEffect(() => {
        dispatch(getOrderById({id},callBack))
    }, [id]);

    function backToOrders() {
        history.push('/orders');
    }

    async function printFactor(id) {
        await trackPromise(axios({
            method: 'post',
            url: strings.baseUrl + `admin/order/print/${id}`,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(result => {
                if (result.data.status_code === 200) {
                    let value = decodeURIComponent(escape(window.atob(result.data.data.factor_image)));
                    const theWindow = window.open();
                    const theDoc = theWindow.document.write(value);
                    const theScript = document.createElement('script');

                    function injectThis() {
                        window.print();
                    }

                    theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
                    theDoc.body.appendChild(theScript);
                    // let data = decodeURIComponent(escape(window.atob(result.data.data.factor_image)));
                    // let w = window.open();
                    // w.document.write(data);
                    // w.print();
                    // w.close();
                } else alert("خطایی رخ داد")
            })
            .catch(error => {
                console.log(error)
            }))
    }

    function ComponentToPrint({myKey}) {
        return (
            <div ref={myKey} className="tablePrintIsNearby" >
                <div className="detailsBoxOrderUserPanelIsNearby" ref={(el) => (componentRef = el)}>
                    <div className="d-flex">
                        <span>تحویل گیرنده:</span>
                        <span>{order?.user?.full_name}</span>
                    </div>
                    <div className="d-flex">
                        <span>شماره تماس:</span>
                        <span>{order?.user?.mobile}</span>
                    </div>
                    {/*<Grid item xs={12} lg={4}>*/}
                    {/*    <h3>کد پیگیری پستی:</h3>*/}
                    {/*    <h4>02788003317204737523 </h4>*/}
                    {/*</Grid>*/}
                    <div className="d-flex">
                        <span>مبلغ کل سفارش:</span>
                        <span>{order?.total_amount ? separate(order?.total_amount) : ''} ریال </span>
                    </div>
                    <div className="d-flex">
                        <span>مبلغ پرداختی:</span>
                        <span>{order?.total_amount ? separate(order?.total_amount - order?.discouted_amount) : ''} ریال </span>
                    </div>

                    {/*<Grid item xs={12} lg={4}>*/}
                    {/*    <h3>ارسال از طریق:</h3>*/}
                    {/*    <h4>پست پیشتاز</h4>*/}
                    {/*</Grid>*/}
                    {order?.discouted_amount !== 0 &&
                    <div className="d-flex">
                        <span>مقدار تخفیف خورده:</span>
                        <span>{separate(order?.discouted_amount)}</span>
                    </div>
                    }
                    <div className="d-flex">
                        <span>مقدار تخفیف:</span>
                        <span>{order?.coupon?.amount ? order?.coupon?.amount?.percent ? `${order?.coupon?.amount?.percent} %` : `${order?.coupon?.amount?.price} ریال` : '0 %' }</span>
                    </div>
                    <div className="d-flex">
                        <span>تاریخ ثبت:</span>
                        <span style={{direction: 'ltr'}}>{order?.created_at}</span>
                    </div>
                    {order?.delivery_amount !== null && (
                        <div className="d-flex">
                            <span>هزینه ارسال:</span>
                            <span>{order?.is_nearby === 1 ? `پرداخت در محل(پیک)` : order?.delivery_amount ? `${separate(order?.delivery_amount)} ریال` : ''}</span>
                        </div>
                    )}
                    {!isMarghoom &&
                    <div className="d-flex">
                        <span>نوع ارسال:</span>
                        <span>{order?.is_nearby === 1 ? 'ارسال با پیک موتوری' : 'ارسال از طریق پست'}</span>
                    </div>
                    }
                    {order?.address?.city &&
                    <div className="d-flex">
                        <span>ارسال به:</span>
                        <span>{order?.address?.city?.province?.name} , {order?.address?.city?.name} , {order?.address?.address}</span>
                    </div>
                    }
                </div>
                <Grid item xs={12} md={8} lg={12} className="DivParentTableProductOfOrder">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">عنوان محصول</TableCell>
                                    <TableCell align="right">قیمت واحد</TableCell>
                                    <TableCell align="center">تعداد</TableCell>
                                    <TableCell align="center">جمع کل</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {order?.products?.length !== 0 && order.products?.map((row, i) => (
                                    // <Unit data={row} key={i}/>
                                    <TableRow key={row.product_id}>
                                        <TableCell component="th" scope="row">
                                            <div className="d-flex BoxBookInTable align-items-center justify-content-center">
                                                {/*<i className="fas fa-times c-pointer"  onClick={() => dispatch({*/}
                                                {/*   type: "DELETE_PRODUCT_OF_CART",*/}
                                                {/*   data: data.product_id*/}
                                                {/*})}/>*/}
                                                <span>{row.name}</span>
                                            </div>
                                        </TableCell>
                                        <TableCell align="right">
                                            <div className="DivParentPriceInTableCart">
                                                {/*<h3 className="percent">%10</h3>*/}
                                                {/*<h3 className="lastPrice">{separate(data.price)} ریال</h3>*/}
                                                <span className="mainPrice">{separate(row.price)} ریال</span>
                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div className="w-100 d-flex justify-content-center align-items-center">
                                                {row.quantity}
                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div className="finalPrice">
                                                <span>{separate(row.price * row.quantity)} ریال</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </div>
        );
    }

    return (
        <Grid item xs={11} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle={`جزئیات سفارش - ${order?.tracking_code}`}
                backBtnTitle="بازگشت"
                backBtnAction={backToOrders}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentTableOrdersUserPanel">
                <div className="divParentStepperUserPanel d-none d-sm-flex">
                    <h3>
                        وضعیت سفارش:
                    </h3>
                    <Stepper activeStep={isMarghoom ? 4 : activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </div>
                <div className="detailsBoxOrderUserPanel">
                    <div className="d-flex">
                        <h3>تحویل گیرنده:</h3>
                        <h4>{order?.user?.full_name}</h4>
                    </div>
                    <div className="d-flex">
                        <h3>شماره تماس:</h3>
                        <h4>{order?.user?.mobile}</h4>
                    </div>
                    {/*<Grid item xs={12} lg={4}>*/}
                    {/*    <h3>کد پیگیری پستی:</h3>*/}
                    {/*    <h4>02788003317204737523 </h4>*/}
                    {/*</Grid>*/}
                    <div className="d-flex">
                        <h3>مبلغ کل سفارش:</h3>
                        <h4>{order?.total_amount ? separate(order?.total_amount) : ''} ریال </h4>
                    </div>

                    {/*<Grid item xs={12} lg={4}>*/}
                    {/*    <h3>ارسال از طریق:</h3>*/}
                    {/*    <h4>پست پیشتاز</h4>*/}
                    {/*</Grid>*/}
                    <div className="d-flex">
                        <h3>مبلغ پرداختی:</h3>
                        <h4>{order?.total_amount ? separate(order?.total_amount - order?.discouted_amount) : ''} ریال </h4>
                    </div>
                    {order?.discouted_amount !== 0 &&
                    <div className="d-flex">
                        <h3>مقدار تخفیف خورده:</h3>
                        <h4>{separate(order?.discouted_amount)}</h4>
                    </div>
                    }
                    <div className="d-flex">
                        <h3>مقدار تخفیف:</h3>
                        <h4>{order?.coupon?.amount ? order?.coupon?.amount?.percent ? `${order?.coupon?.amount?.percent} %` : `${order?.coupon?.amount?.price} ریال` : '0 %' }</h4>
                    </div>
                    <div className="d-flex">
                        <h3>تاریخ ثبت:</h3>
                        <h4 style={{direction: 'ltr'}}>{order?.created_at}</h4>
                    </div>
                    {order?.delivery_amount !== null && (
                        <div className="d-flex">
                            <h3>هزینه ارسال:</h3>
                            <h4>{order?.is_nearby === 1 ? `پرداخت در محل(پیک)` : order?.delivery_amount ? `${separate(order?.delivery_amount)} ریال` : ''}</h4>
                        </div>
                    )}
                    {!isMarghoom &&
                    <div className="d-flex">
                        <h3>نوع ارسال:</h3>
                        <h4>{order?.is_nearby === 1 ? 'ارسال با پیک موتوری' : 'ارسال از طریق پست'}</h4>
                    </div>
                    }
                    {order?.address?.city &&
                    <div className="d-flex">
                        <h3>ارسال به:</h3>
                        <h4>{order?.address?.city?.province?.name} , {order?.address?.city?.name} , {order?.address?.address}</h4>
                    </div>
                    }
                </div>
                <div className="d-flex justify-content-end allViewGoods">
                    <h3 className="viewInvoice">مشاهده فاکتور</h3>
                    <div
                        className="d-flex viewGoods"
                        onClick={() => setViewGoods(!viewGoods)}
                    >
                        <i className={`${viewGoods ? `fas fa-chevron-up` : `fas fa-chevron-down`}`}/>
                        <h3>
                            مشاهده کالا
                        </h3>
                    </div>
                </div>
                {viewGoods &&
                <Grid item xs={12} md={8} lg={12} className="DivParentTableProductOfOrder">
                    <TableContainer component={Paper} className="d-none d-sm-block">
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>عنوان محصول</TableCell>
                                    <TableCell align="right">قیمت واحد</TableCell>
                                    <TableCell align="right">تعداد</TableCell>
                                    <TableCell align="right">جمع کل</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {order?.products?.length !== 0 && order.products?.map((row, i) => (
                                    <Unit data={row} key={i}/>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className="d-flex flex-column d-sm-none">
                        {order?.products?.length !== 0 && order?.products?.map((row, i) => (
                            <BookBoxDrawerCart data={row} key={i} disabled/>
                        ))
                        }
                    </div>
                </Grid>
                }


                <div className="d-flex flex-column flex-sm-row justify-content-sm-between my-4 pl-3 align-items-center">
                    {!isMarghoom && (
                        <div className="d-flex justify-content-start">
                            <div className='w-max position-relative'>
                                {order?.is_nearby === 1
                                    ?
                                    <Button
                                        variant="contained"

                                        className="continuationButtonCreateProduct ml-3 mr-4"
                                        onClick={()=> document.getElementById('printButton').click()}

                                    >
                                        پرینت فاکتور
                                    </Button>
                                    :
                                    <Button
                                        variant="contained"

                                        className="continuationButtonCreateProduct ml-3 mr-4"
                                        disabled={orderBarcode === null}
                                        onClick={() =>printFactor(order?.id)}

                                    >
                                        پرینت فاکتور
                                    </Button>
                                }
                                {/*{loadingFactor && <CircularProgress size={24} className="loadingButton"/>}*/}
                            </div>
                            <div className="w-max position-relative">
                                <Button
                                    variant="contained"
                                    className="ml-3 mr-4"
                                    disabled={activeStep !== 1}
                                    onClick={() => dispatch(changeOrderStatus(
                                        {id: order?.topin_order_id, status: 1,is_nearby: order?.is_nearby},
                                        (stat) => {
                                            setActiveStep(stat.status+1);
                                            setOrderBarcode(stat.barcode)
                                        }
                                    ))}
                                >
                                    تایید فروشگاه
                                </Button>
                                {/*{activeStep === 1 && loadingStatus &&*/}
                                {/*<CircularProgress size={24} className="loadingButton"/>}*/}
                            </div>
                            <div className="w-max position-relative">
                                <Button
                                    variant="contained"

                                    className="ml-3 mr-4"
                                    disabled={activeStep !== 2}
                                    onClick={() => dispatch(changeOrderStatus(
                                        {id: order?.topin_order_id, status: 2,is_nearby: order?.is_nearby},
                                        (stat) => {
                                            setActiveStep(stat.status+1);
                                            setOrderBarcode(stat.barcode)
                                        }
                                    ))}
                                >
                                    تایید انبار
                                </Button>
                                {/*{activeStep === 2 && loadingStatus &&*/}
                                {/*<CircularProgress size={24} className="loadingButton"/>}*/}
                            </div>
                        </div>
                    )}
                    {orderBarcode !== null && (
                        <div className="d-none d-sm-block">
                            <a
                                href={`https://tracking.post.ir/?id=${orderBarcode}&client=app`}
                                style={{textDecoration: "none"}}
                            >
                                <h3 className="followOfPost">پیگیری مرسوله از اداره پست</h3>
                            </a>
                        </div>
                    )}
                </div>
                <ReactToPrint
                    trigger={() => <Button id="printButton" style={{visibility: "hidden"}}>Print this out!</Button>}
                    content={() => componentRef}
                />
                <div>
                    <ComponentToPrint myKey={(el) => (componentRef = el)} />
                </div>
            </Paper>
        </Grid>
    )
}
